import { cva } from 'class-variance-authority';

export const testimonialCardStyle = cva(
  'dark-gray-gradient-testimonial-card flex w-full flex-col items-start justify-between gap-6 rounded-lg border border-solid border-gray-300 p-6 text-white shadow-xl sm:gap-8 sm:p-8 ',
  {
    variants: {
      variation: {
        quote: '',
        g2: 'flex-col-reverse',
        ratingCards: 'gap-8 p-8',
      },
    },
  },
);

export const contentStyle = cva('text-lg', {
  variants: {
    current: {
      true: ['text-xl'],
    },
  },
  defaultVariants: {
    current: false,
  },
});

export const testimonialCompanyLogoStyle = cva('h-10 w-auto max-w-[100px] brightness-0 invert [&_img]:object-contain', {
  variants: {
    variation: {
      quote: '',
      g2: 'hidden',
      ratingCards: 'hidden',
    },
  },
});

export const testimonialHeadshotStyle = cva('size-16 rounded border-2 border-solid border-primary-200 object-cover', {
  variants: {
    variation: {
      quote: '',
      g2: 'rounded-full',
      ratingCards: 'hidden',
    },
  },
});

export const testimonialNameStyle = cva('font-spaceGrotesk font-semibold text-primary-200', {
  variants: {
    isActive: {
      true: 'text-display-xs',
      false: 'text-xl',
    },
  },
  defaultVariants: {
    isActive: false,
  },
});
